module.exports = __webpack_public_path__ + "img/faining.dfa64869.svg";